export default __webpack_public_path__ + "static/media/NIRF.0f0aa509.png";